import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Modal from 'components/Modal';

export const MAX_ICONS_PER_KIT = 'MAX_ICONS_PER_KIT';
export const MAX_CUSTOM_ICONS = 'MAX_CUSTOM_ICONS';
export const NO_CUSTOM_ICONS_ALLOWED = 'NO_CUSTOM_ICONS_ALLOWED';
export const MAX_TYPEFACES_PER_KIT = 'MAX_TYPEFACES_PER_KIT';
export const NO_CUSTOM_TYPEFACES_ALLOWED = 'NO_CUSTOM_TYPEFACES_ALLOWED';

const ALL_REASONS = [
  MAX_ICONS_PER_KIT,
  MAX_CUSTOM_ICONS,
  NO_CUSTOM_ICONS_ALLOWED,
  MAX_TYPEFACES_PER_KIT,
  NO_CUSTOM_TYPEFACES_ALLOWED,
];

export default createReactClass({
  propTypes: {
    reason: PropTypes.oneOf(ALL_REASONS),
    subscription: ImmutablePropTypes.record,
    isOpen: PropTypes.bool.isRequired,
    onOkayClicked: PropTypes.func.isRequired,
    onUpgradeClicked: PropTypes.func.isRequired,
    onCloseClicked: PropTypes.func.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  handleOkayClicked(event) {
    event.preventDefault();

    this.props.onOkayClicked();
  },

  handleUpgradeClicked(event) {
    event.preventDefault();

    this.props.onUpgradeClicked();
  },

  handleCloseClicked(event) {
    if (event) {
      event.preventDefault();
    }

    this.props.onCloseClicked();
  },

  render() {
    let title = null;
    let message = null;

    if (this.props.reason === MAX_ICONS_PER_KIT) {
      title = 'Icon Limit Reached';
      message = (
        <div>
          Oh noes! It looks like you’ve hit the max number of icons per kit allowed by
          your plan ({this.props.subscription.iconsPerKitAllowed}).
          Feel free to remove icons or upgrade now to keep adding!
        </div>
      );
		} else if (this.props.reason === MAX_CUSTOM_ICONS) {
      title = 'Upgrade for more Custom Icons';
      message = (
        <div>
          Aw heck! You&rsquo;re plan is limited to {this.props.subscription.customIconsAllowed} custom icons.
          Upgrade your account to upload more!
        </div>
      );
    } else if (this.props.reason === NO_CUSTOM_ICONS_ALLOWED) {
      title = 'Upgrade for Custom Icons';
      message = (
        <div>
          Aw heck! You&rsquo;re on a plan that doesn&rsquo;t allow custom icons.
          Upgrade your account now to start uploading!
        </div>
      );
    } else if (this.props.reason === MAX_TYPEFACES_PER_KIT) {
      title = 'Typeface Limit Reached';
      message = (
        <div>
          Oh noes! It looks like you’ve hit the max number of typefaces per kit allowed by
          your plan ({this.props.subscription.workingSetTypefacesAllowed}).
          Feel free to remove typefaces or upgrade now to keep adding!
        </div>
      );
    } else if (this.props.reason === NO_CUSTOM_TYPEFACES_ALLOWED) {
      title = 'Upgrade for Custom Typefaces';
      message = (
        <div>
          Aw heck! You&rsquo;re on a plan that doesn&rsquo;t allow custom typefaces.
          Upgrade your account now to start uploading!
        </div>
      );
    }
    return (
      <Modal contentLabel={title || ""} isOpen={this.props.isOpen} onRequestClose={this.handleCloseClicked}>
        <div className="modal-content">
          <div className="modal-header bg-primary dashed dashed-bottom m-xs-b-xs p-xs-b-sm">
            <button onClick={this.handleCloseClicked} type="button" className="close close-dangle" data-dismiss="modal">
              <span aria-hidden="true"><i className="ficon ficon-times"></i></span><span className="sr-only">Close</span>
            </button>
            <h3 className="modal-title">{title}</h3>
          </div>
          <div className="modal-body">
            <div className="text-lg m-xs-b-0 p-xs-a-lg">
              <div className="row">
                <div className="col-xs-2">
                  <i className="ficon ficon-level-up-circle ficon-3x text-gray-lighter"></i>
                </div>
                <div className="col-xs-10 p-xs-l-0">
                  {message}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer bg-body">
            <a href="#" onClick={this.handleOkayClicked} className="btn btn-link btn-secondary" data-dismiss="modal">Okay</a>
            <a href="#" onClick={this.handleUpgradeClicked} className="btn btn-lg btn-primary">Upgrade<i className="ficon ficon-level-up-circle p-xs-l-xs"></i></a>
          </div>
        </div>
      </Modal>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/UpgradeModal.js